export const formAutofillSuppressAttributes = {
    autocomplete: "off",
    "data-1p-ignore": "",
    "data-op-ignore": "true",
    "data-lpignore": "true",
    "data-bwignore": "true",
    "data-protonpass-ignore": "true",
    "data-form-type": "other",
};

export const suppressFormAutofill = (element) => {
    if (!(element instanceof HTMLElement)) {
        return;
    }

    for (const [name, value] of Object.entries(formAutofillSuppressAttributes)) {
        element.setAttribute(name, value);
    }
};

export const suppressChoicesSearchAutofill = (choicesInstance) => {
    const searchInput = choicesInstance?.input?.element;

    if (searchInput instanceof HTMLElement) {
        suppressFormAutofill(searchInput);
    }
};

export const suppressFlatpickrAltInputAutofill = (flatpickrInstance) => {
    const altInput = flatpickrInstance?.altInput;

    if (altInput instanceof HTMLElement) {
        suppressFormAutofill(altInput);
    }
};
